import { ref, reactive } from 'vue'
function loadComponentsByCondition(components, condition, callback) {
  console.log(condition, 'device')
  let specified = components[condition]

  if (!specified) return

  let specifiedComponents = reactive(components[condition])
  let allPromise = []
  for (let com in specifiedComponents) {
    allPromise.push(specifiedComponents[com]())
  }
  Promise.all(allPromise).then(rs => {
    let tmp
    Object.keys(specifiedComponents).map((k, i) => {
      tmp = rs[i]
      specifiedComponents[k] = tmp || {}
      // console.log('map[k]', specifiedComponents[k])
    })
    callback && callback(specifiedComponents)
  })
  return specifiedComponents
}

export default loadComponentsByCondition
